import React from 'react';
import { AdvancedImage, lazyload, placeholder, responsive } from '@cloudinary/react';
import { TextVariant } from '@naf/text';
import { spacing } from '@naf/theme';
import { HeroContentType } from '@appTypes/CategoryAppType';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';
import * as S from './HeroContent.styles';
import Countdown from './Countdown';

type HeroContentProps = {
  heroContent: HeroContentType;
};

const HeroContent = ({ heroContent }: HeroContentProps) => {
  const { getResponsiveImage } = useCloudinary();
  const cldImage = getResponsiveImage(heroContent.logoImage?.publicId);

  return (
    <S.HeroWrapper>
      {cldImage ? (
        <S.ImageWrapper>
          <AdvancedImage
            style={{ maxHeight: spacing.space32 }}
            alt={heroContent.logoImage?.altText}
            cldImg={cldImage}
            plugins={[
              lazyload({ rootMargin: '10px 20px 10px 30px', threshold: 0.25 }),
              responsive({ steps: 200 }),
              placeholder({ mode: 'blur' }),
            ]}
          />
        </S.ImageWrapper>
      ) : null}
      <S.TitleText variant={TextVariant.Display}>{heroContent.pageTitle}</S.TitleText>
      {heroContent.countdown ? <Countdown countdown={heroContent.countdown} /> : null}
    </S.HeroWrapper>
  );
};

export { HeroContent };
